import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
	calcUstav,
	CRITERION_USTAV,
	DEFAULT_CRETIONS,
	MATRIX_USTAV,
	NUMBERS_USTAV,
	SOLE_EXECUTIVE_BODY,
	TYPE_MODAL_USTAV,
} from 'Pages/registratorCabinet'

export type UstavState = {
	numberUstav: NUMBERS_USTAV
	selectUstav: NUMBERS_USTAV
	viewUstav: NUMBERS_USTAV
	typeModal: TYPE_MODAL_USTAV
	criterions: Record<CRITERION_USTAV, boolean | SOLE_EXECUTIVE_BODY>
	activeUstavs: Record<Partial<NUMBERS_USTAV>, boolean>
}

export const ustavInitialState: UstavState = {
	selectUstav: null,
	numberUstav: null,
	viewUstav: null,
	typeModal: null,
	criterions: DEFAULT_CRETIONS,
	activeUstavs: calcUstav(DEFAULT_CRETIONS),
}

export namespace UstavNS {
	export type SetSelectUstav = PayloadAction<NUMBERS_USTAV>
	export type SetNumberUstav = PayloadAction<NUMBERS_USTAV>
	export type SetViewUstav = PayloadAction<NUMBERS_USTAV>
	export type SetTypeModal = PayloadAction<TYPE_MODAL_USTAV>
	export type ChangeCriterions = PayloadAction<{
		value: boolean | SOLE_EXECUTIVE_BODY
		criterion: CRITERION_USTAV
	}>
	export type ClearAll = PayloadAction
}

export const ustavSlice = createSlice({
	name: 'ustav',
	initialState: ustavInitialState,
	reducers: {
		setSelectUstav: (state, action: UstavNS.SetSelectUstav) => {
			state.selectUstav = action.payload
		},
		setViewUstav: (state, action: UstavNS.SetViewUstav) => {
			state.viewUstav = action.payload
		},
		setNumberUstav: (state, action: UstavNS.SetNumberUstav) => {
			state.numberUstav = action.payload
			state.viewUstav = action.payload
			state.selectUstav = action.payload
			const criterionsNumberUstav = {
				[CRITERION_USTAV.FIRST]: MATRIX_USTAV[action.payload][CRITERION_USTAV.FIRST],
				[CRITERION_USTAV.SECOND]: MATRIX_USTAV[action.payload][CRITERION_USTAV.SECOND],
				[CRITERION_USTAV.THREE]: MATRIX_USTAV[action.payload][CRITERION_USTAV.THREE],
				[CRITERION_USTAV.FOUR]: MATRIX_USTAV[action.payload][CRITERION_USTAV.FOUR],
				[CRITERION_USTAV.FIVE]: MATRIX_USTAV[action.payload][CRITERION_USTAV.FIVE],
				[CRITERION_USTAV.SIX]: MATRIX_USTAV[action.payload][CRITERION_USTAV.SIX],
				[CRITERION_USTAV.SEVEN]: MATRIX_USTAV[action.payload][CRITERION_USTAV.SEVEN],
			}
			state.criterions = criterionsNumberUstav
			state.activeUstavs = calcUstav(criterionsNumberUstav)
		},
		setTypeModal: (state, action: UstavNS.SetTypeModal) => {
			state.typeModal = action.payload
		},
		changeCriterions: (state, action: UstavNS.ChangeCriterions) => {
			const { value, criterion } = action.payload
			const newCriterions = { ...state.criterions, [criterion]: value }
			state.criterions = newCriterions
			const newActiveUstavs = calcUstav(newCriterions)
			if (!newActiveUstavs[state.selectUstav]) state.selectUstav = null
			state.activeUstavs = newActiveUstavs
		},
		clearAll: (state, action: UstavNS.ClearAll) => {
			state.selectUstav = null
			state.numberUstav = null
			state.viewUstav = null
			state.typeModal = null
			state.criterions = DEFAULT_CRETIONS
			state.activeUstavs = calcUstav(DEFAULT_CRETIONS)
		},
	},
})
